import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import {
  AutoForecastPolicySettingApi,
  CreateMultiAutoForecastPolicySettingBody,
  DeleteMultiAutoForecastPolicySettingBody,
  FilterAutoForecastPolicySettingOptions,
} from 'api';

export const createMultiAutoForecastPolicySetting = createAsyncThunk(
  'autoForecastPolicySetting/createMultiAutoForecastPolicySetting',
  async (
    body: CreateMultiAutoForecastPolicySettingBody,
    { rejectWithValue }
  ) => {
    try {
      const response = await AutoForecastPolicySettingApi.createMulti(body);
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteMultiAutoForecastPolicySetting = createAsyncThunk(
  'autoForecastPolicySetting/deleteMultiAutoForecastPolicySetting',
  async (
    body: DeleteMultiAutoForecastPolicySettingBody,
    { rejectWithValue }
  ) => {
    try {
      const response = await AutoForecastPolicySettingApi.deleteMulti(body);
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findAutoForecastPolicySetting = createAsyncThunk(
  'autoForecastPolicySetting/findAutoForecastPolicySetting',
  async (
    option: FilterAutoForecastPolicySettingOptions,
    { rejectWithValue }
  ) => {
    try {
      const response = await AutoForecastPolicySettingApi.filter(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteAutoForecastPolicySetting = createAsyncThunk(
  'autoForecastPolicySetting/deleteAutoForecastPolicySetting',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await AutoForecastPolicySettingApi.delete(id);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface State {
  data: any;
}

const initialState: State = {
  data: [],
};

const autoForecastPolicySettingSlice = createSlice({
  name: 'autoForecastPolicySetting',
  initialState,
  reducers: {},
});

const { actions, reducer: autoForecastPolicySettingReducer } =
  autoForecastPolicySettingSlice;

export default autoForecastPolicySettingReducer;
